export const AuthEventName = {
  submitPasswordsForm: "submitPasswordsForm",
  submitPasswordsSuccess: "submitPasswordsSuccess",
  submitLoginForm: "submitLoginForm",
  submitLoginSuccess: "submitLoginSuccess",
  submitLoginFailed: "submitLoginFailed",
  submitLoginIdForm: "submitLoginIdForm",
  submitLoginPasswordForm: "submitLoginPasswordForm",
  switchToOtpLogin: "switchToOtpLogin",
  switchToPasswordLogin: "switchToPasswordLogin",
  bookInvestmentSession: "bookInvestmentSession",
  forgotPassword: "forgotPassword",
  submitResetPasswordForm: "submitResetPasswordForm",
  viewResetPasswordRequestFinalStep: "viewResetPasswordRequestFinalStep",
  viewOtpScreen: "viewOtpScreen",
  submitOtpForm: "submitOtpForm",
  resendOtp: "resendOtp",
  openEmailApp: "openEmailApp",
} as const;

export type AuthEventName = (typeof AuthEventName)[keyof typeof AuthEventName];
